import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Card from "./Card";
import Modal from "./Modal";
import ThreeWayToggle from "./ThreeWayToggle";
import FilterCards from "./FilterCards";
import SearchBar from "./SearchBar";
import Fuse from "fuse.js";
import keys from "../config";
import shuffle from "shuffle-array";
import "../style/CardGrid.css";

export class CardGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfs: null,
      searchQueries: [],
      tagFilters: [],
      modalOpen: false,
      modalIframeSrc: null,
      downloadFn: null,
      pdfSliceBegin: 0,
      showPagination: false,
      titleMode: "English/Latin",
      titleOfModalClick: null,
      shuffled: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.iframeSrc = this.iframeSrc.bind(this);
    this.addSearchQuery = this.addSearchQuery.bind(this);
    this.removeSearchQuery = this.removeSearchQuery.bind(this);
    this.addTagFilter = this.addTagFilter.bind(this);
    this.removeTagFilter = this.removeTagFilter.bind(this);
    this.renderCards = this.renderCards.bind(this);
    this.filterByPdfCategories = this.filterByPdfCategories.bind(this);
    this.changeTitleMode = this.changeTitleMode.bind(this);
    this.sendTitleToModal = this.sendTitleToModal.bind(this);
  }
  async componentDidMount() {
    let titlePreference = "English/Latin";
    if (localStorage.getItem("titlePref")) {
      titlePreference = localStorage.getItem("titlePref");
    }
    const url = keys.musicUrl;
    const pdfs = await axios.get(url);
    this.setState({
      pdfs: pdfs.data.results.Items,
      titleMode: titlePreference,
    });
    window.x = pdfs.data.results.Items;
  }
  changeTitleMode(titleMode) {
    localStorage.setItem("titlePref", titleMode);
    this.setState({
      titleMode,
    });
  }
  filterByPdfCategories(pdf) {
    const selectedTags = this.state.tagFilters; // array of tags
    const pdfCategories = pdf.category.split(",");
    let matches = 0; // tally the number of matches

    for (let i = 0; i < pdfCategories.length; i++) {
      if (selectedTags.includes(pdfCategories[i])) {
        matches++;
      }
    }

    // const setOfCategories = new Set(this.state.tagFilters);
    // const pdfCategories = pdf.category.split(",");
    // for (let i = 0; i < pdfCategories.length; i++) {
    //   if (setOfCategories.has(pdfCategories[i])) {
    //     console.log("MATCH");
    //     includeThisPdf = true;
    //   }
    // }
    if (matches === selectedTags.length) {
      // All selected tags were matched
      return true;
    } else {
      // if all the tags weren't matched, don't include pdf
      return false;
    }
  }
  toggleModal(downloadFn) {
    this.setState((prevState) => {
      return {
        downloadFn,
        modalOpen: !prevState.modalOpen,
      };
    });
  }
  iframeSrc(src) {
    this.setState({
      modalIframeSrc: src,
    });
  }
  sendTitleToModal(title) {
    this.setState({
      titleOfModalClick: title,
    });
  }
  renderCards() {
    // USING fuse.js TO SEARCH
    const options = {
      shouldSort: true,
      threshold: 0.15,
      location: 0,
      distance: 80,
      maxPatternLength: 32,
      minMatchCharLength: 3,
      keys: [
        { name: "pieceName", weight: 0.3 },
        { name: "filename", weight: 0.2 },
        { name: "composer", weight: 0.3 },
        { name: "category", weight: 0.2 },
      ],
    };
    const fuse = new Fuse(this.state.pdfs, options);

    // as the conditionals flow, this will be mutated
    let searchResult = this.state.pdfs; // default value
    if (
      this.state.searchQueries.length < 1 &&
      this.state.tagFilters.length < 1
    ) {
      // only provide pagination for returning all PDFs
      const { pdfSliceBegin } = this.state;
      const pdfSliceEnd = pdfSliceBegin + 15;
      searchResult = searchResult
        .sort((a, b) => sortByPieceName(a, b, this.state.titleMode === "Latin"))
        .slice(pdfSliceBegin, pdfSliceEnd);
      if (this.state.searchQueries.length < 1 && !this.state.shuffled) {
        this.setState({ shuffled: true });
        console.log("SHUFFLING");
        // As per the request, we shuffle the order
        searchResult = shuffle(searchResult);
      }
      return searchResult
        .sort((a, b) => sortByPieceName(a, b, this.state.titleMode === "Latin"))
        .map((pdf) => (
          <Card
            titleMode={this.state.titleMode}
            key={pdf.filename}
            toggleModal={this.toggleModal}
            iframeSrc={this.iframeSrc}
            pdf={pdf}
            sendTitleToModal={this.sendTitleToModal}
          />
        ));
    }

    if (
      this.state.tagFilters.length > 0 &&
      this.state.searchQueries.length === 0
    ) {
      // this is the case where there is no input
      // from the search bar. In this case,
      // if there are any tags from the drop down
      // they will strictly filter through the cards

      // const currentlySelectedFilters = this.state.tagFilters;
      searchResult = searchResult.filter((pdf) =>
        this.filterByPdfCategories(pdf, this.state.tagFilters)
      );
      return searchResult.map((pdf) => (
        <Card
          titleMode={this.state.titleMode}
          key={pdf.filename}
          toggleModal={this.toggleModal}
          iframeSrc={this.iframeSrc}
          pdf={pdf}
          sendTitleToModal={this.sendTitleToModal}
        />
      ));
    }

    if (this.state.searchQueries.length > 1) {
      const { searchQueries } = this.state;
      for (let i = 0; i < searchQueries.length; i++) {
        searchResult = fuse.search(searchQueries[i]);
      }
    }
    if (this.state.searchQueries.length < 2) {
      const searchSentence = this.state.searchQueries.join(" ");
      searchResult = fuse.search(searchSentence);

      // `searchResult` is NOW the result of the search bar
      // if there are any tags selected from the drop-downs
      // then we need to furthermore filter the pdfs
      if (
        this.state.tagFilters.length > 0 &&
        this.state.searchQueries.length > 0
      ) {
        // This is the cae where there is search input & tags selected
        searchResult = searchResult.filter((pdf) =>
          this.filterByPdfCategories(pdf, [
            ...this.state.tagFilters,
            ...this.state.searchQueries,
          ])
        );
      }
      if (searchResult.length < 1) {
        return (
          <div className="no-search-container">
            <h1 className="no-search">No motets found with that search</h1>
            <p>
              <Link to="/contact">
                Contact us if you have a requested motet to be "Englished."
              </Link>
            </p>
          </div>
        );
      }
      // categories will filter much more strictly
      return searchResult
        .sort((a, b) => sortByPieceName(a, b, this.state.titleMode === "Latin"))
        .map((pdf) => (
          <Card
            titleMode={this.state.titleMode}
            key={pdf.filename}
            toggleModal={this.toggleModal}
            iframeSrc={this.iframeSrc}
            pdf={pdf}
            sendTitleToModal={this.sendTitleToModal}
          />
        ));
    }

    return searchResult
      .sort((a, b) => sortByPieceName(a, b, this.state.titleMode === "Latin"))
      .map((pdf) => (
        <Card
          titleMode={this.state.titleMode}
          key={pdf.filename}
          toggleModal={this.toggleModal}
          iframeSrc={this.iframeSrc}
          pdf={pdf}
          sendTitleToModal={this.sendTitleToModal}
        />
      ));
  }
  addSearchQuery(queryTerm) {
    let elements = queryTerm.split(" ");

    this.setState((prevState) => {
      return {
        searchQueries: [...prevState.searchQueries, ...elements],
      };
    });
  }
  addTagFilter(queryTerm) {
    // let elements = queryTerm.split(" ");

    this.setState((prevState) => {
      return {
        tagFilters: [...prevState.tagFilters, queryTerm],
      };
    });
  }
  removeTagFilter(queryTermToRemove) {
    if (typeof queryTermToRemove === "string") {
      // const toRemove = queryTermToRemove.split(" ");
      const modifiedTagList = this.state.tagFilters.filter(
        (query) => queryTermToRemove.indexOf(query) === -1
      );
      return this.setState({
        tagFilters: modifiedTagList,
      });
    }
    const modifiedTagList = this.state.tagFilters.filter(
      (query) => query !== queryTermToRemove
    );
    this.setState({
      tagFilters: modifiedTagList,
    });
  }
  removeSearchQuery(queryTermToRemove) {
    if (typeof queryTermToRemove === "string") {
      const toRemove = queryTermToRemove.split(" ");
      const modifiedSearchQueries = this.state.searchQueries.filter(
        (query) => toRemove.indexOf(query) === -1
      );
      return this.setState({
        searchQueries: modifiedSearchQueries,
      });
    }
    const modifiedSearchQueries = this.state.searchQueries.filter(
      (query) => query !== queryTermToRemove
    );
    this.setState({
      searchQueries: modifiedSearchQueries,
    });
  }
  render() {
    const isFirefox = typeof InstallTrigger !== "undefined";
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const body = document.querySelectorAll("body")[0];
    body.classList.remove("freeze");
    // if (!isFirefox && !isSafari) {
    //   const body = document.querySelectorAll("body")[0];
    //   body.classList.remove("freeze");
    // }
    const footer = document.getElementById("footer");
    if (this.state.modalOpen) {
      footer && (footer.style.zIndex = "-1");
    } else {
      footer && (footer.style.zIndex = "500");
    }
    return (
      <div>
        <div className="console">
          {this.state.pdfs && (
            <FilterCards
              pdfs={this.state.pdfs}
              addSearchQuery={this.addTagFilter}
              removeSearchQuery={this.removeTagFilter}
            />
          )}
          <SearchBar
            addSearchQuery={this.addSearchQuery}
            removeSearchQuery={this.removeSearchQuery}
          />
        </div>

        <ThreeWayToggle changeTitleMode={this.changeTitleMode} />
        {this.state.pdfs &&
          this.state.searchQueries.length < 1 &&
          this.state.tagFilters.length < 1 && (
            <div className="pagination-controller">
              <p
                className="pagination-controller-btn pagination-controller-btn_back"
                onClick={(e) =>
                  this.setState((prevState) => {
                    if (prevState.pdfSliceBegin - 15 <= 0) {
                      const originalSlice = 0;
                      return {
                        pdfSliceBegin: originalSlice,
                      };
                    }
                    if (prevState.pdfSliceBegin > 0) {
                      // avoid negatives
                      return {
                        pdfSliceBegin: prevState.pdfSliceBegin - 15,
                      };
                    }
                  })
                }
              >
                Back
              </p>
              <p>
                Results {this.state.pdfSliceBegin + 1}-
                {this.state.pdfSliceBegin + 15} ({this.state.pdfs.length} total)
              </p>
              <p
                className="pagination-controller-btn pagination-controller-btn_next"
                onClick={(e) =>
                  this.setState((prevState) => {
                    if (
                      prevState.pdfSliceBegin + 30 <=
                      this.state.pdfs.length
                    ) {
                      return {
                        pdfSliceBegin: prevState.pdfSliceBegin + 15,
                      };
                    } else {
                      const finalSlice = this.state.pdfs.length - 15;
                      return {
                        pdfSliceBegin: finalSlice,
                      };
                    }
                  })
                }
              >
                Next
              </p>
            </div>
          )}
        <div className="card-grid">
          {!this.state.pdfs && <span>&nbsp;</span>}
          {!this.state.pdfs && (
            <div className="spinner spinner-5 card-grid-spinner">
              <span />
              <span />
              <span />
            </div>
          )}
          {!this.state.modalOpen && this.state.pdfs && this.renderCards()}
        </div>
        {this.state.modalOpen &&
          Modal(
            this.state.modalIframeSrc,
            this.toggleModal,
            this.state.downloadFn,
            this.state.titleOfModalClick
          )}
      </div>
    );
  }
}

export default CardGrid;

function sortByPieceName(pieceOne, pieceTwo, isUsingLatinTitles = false) {
  try {
    const titleIndex = isUsingLatinTitles ? 1 : 0;

    const titleOne = pieceOne.pieceName
      .split("/")
      [titleIndex].toLowerCase()
      .trim();

    const titleTwo = pieceTwo.pieceName
      .split("/")
      [titleIndex].toLowerCase()
      .trim();

    return titleOne.localeCompare(titleTwo, "en", {
      ignorePunctuation: true,
    });
  } catch (error) {
    console.error("sortByPieceName:", error);
    return "".localeCompare("", "en", {
      ignorePunctuation: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/CardGrid.js